# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://coffeescript.org/
$ ->
  $('[data-provider="summernote"]').each ->
    $(this).summernote {
      toolbar: [
        ["style", ["style"]],
        ["font", ["bold", "underline", "clear"]],
        ["fontname", ["fontname"]],
        ["color", ["color"]],
        ["para", ["ul", "ol", "paragraph"]],
        ["insert", ["link"]],
        ["view", ["fullscreen", "codeview", "help"]]
        ],
      lang: 'da-DK',
      minHeight: 200
    }

  $("form.simple_form.edit_setting").on "keypress", (e) ->
    if e.keyCode == 13
      return false
